import './Home.css';
import Navbar from './Navbar';
import {React} from 'react';
import DraggablePictures from './DraggablePictures';

function App() {

  return (
    <div className="content-home"> 
      <Navbar />
    <div className="background-home">
      <div className="overlay">
        <div style={{ overflow: 'hidden' }} className="content">
          <div>
            <DraggablePictures/>
        </div>
      </div>
    </div>
  </div>
  </div>
  );
}

export default App;
